import { flexDirections, tw } from "@sveabank/cc-common";

type Props = {
	children: React.ReactNode;
	fullWidth?: boolean;
	direction?: "row" | "col";
	boxShadow?: boolean;
	stretch?: boolean;
	classNames?: string;
};

const Card = ({
	children,
	fullWidth,
	direction = "row",
	boxShadow = true,
	stretch,
	classNames,
}: Props) => {
	const classes = tw(
		`tablet:w-auto tablet:flex-row z-10 flex w-full flex-col self-start rounded-lg px-6 py-4 text-left`,
		"bg-background-primary",
		boxShadow && "drop-shadow-lg",
		fullWidth && "tablet:w-full",
		stretch && "self-stretch",
		flexDirections[direction],
		classNames,
	);

	return <div className={classes}>{children}</div>;
};

export default Card;
